import { Ao, AoDto, BaseQueryParams, IResponsePaginate, Ppm, PpmMilestone, WithMetadata } from '@/types';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface AoQuery extends BaseQueryParams {}

@Injectable({
  providedIn: 'root',
})
export class AoService {
  BASEURL_AO = `${environment.api.dacUrl}/appel-offre`;

  httpClient = inject(HttpClient);

  // AOs
  getAos(params?: AoQuery): Observable<IResponsePaginate<Ao>> {
    return this.httpClient.get<IResponsePaginate<Ao>>(`${this.BASEURL_AO}`, { params: params as HttpParams });
  }

  getAo(id: number): Observable<Ao> {
    return this.httpClient.get<Ao>(`${this.BASEURL_AO}/${id}`);
  }

  // PPMs
  getAvailablePpms(): Observable<WithMetadata<Ppm>[]> {
    return this.httpClient.get<WithMetadata<Ppm>[]>(`${this.BASEURL_AO}/ppm`);
  }

  // Milestones
  getAvailableMilestones(ppmId: number, ppmVer: number): Observable<WithMetadata<PpmMilestone>[]> {
    return this.httpClient.get<WithMetadata<PpmMilestone>[]>(`${this.BASEURL_AO}/ppm/realisation/${ppmId}/${ppmVer}`);
  }

  addAo(ao: AoDto): Observable<Ao> {
    return this.httpClient.post<Ao>(`${this.BASEURL_AO}`, ao);
  }

  updateAo(id: number, ao: AoDto): Observable<Ao> {
    return this.httpClient.put<Ao>(`${this.BASEURL_AO}/${id}`, ao);
  }
}
